import { render } from "./CommunicationFeedComponent.vue?vue&type=template&id=74feca53"
import script from "./CommunicationFeedComponent.vue?vue&type=script&lang=js"
export * from "./CommunicationFeedComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__